/**
 * Created by jacmai on 2/27/2017.
 */

define(["marionette", "modules/actions/actionGroup/template/actionGroupTemplate.html"], function (
  Marionette,
  ActionGroupTemplate,
) {
  var ActionGroupView = {};

  ActionGroupView.actionGroupLayout = Marionette.Layout.extend({
    template: ActionGroupTemplate,
    className: "max-height",
    regions: {
      actionGroupInfo: "#actionGroupInfo",
      actionGroupItems: "#actionGroupItems",
    },
  });

  return ActionGroupView;
});
